import React from 'react';
import { node } from 'prop-types';
import { useRequests } from '../../../../redux/reducer/requests';

export default function HeaderMenu({ menu }) {
  const {
    authData: { isWeb },
  } = useRequests();

  return (
    <label htmlFor={'menu-burger'} className={'header__wrapper custom-header__wrapper'}>
      <div className={`header__content custom-header__content ${isWeb ? '' : 'app'}`}>{menu}</div>
    </label>
  );
}

HeaderMenu.propTypes = {
  menu: node,
};
